import { schema } from 'normalizr';
import { compose, prop } from 'ramda';

import { DocumentType } from '../../../types/document';
import { toDocType } from '../mapping';
import { Agenda } from './agenda';
import { Article } from './article';
import { BranchActivities } from './branch-activities';
import { Contact } from './contact';
import { ContactPage } from './contact-page';
import { FinancialDebt } from './financial-debt';
import { FinancialKeyFigures } from './financial-key-figures';
import { FinancialPressRelease } from './financial-press-release';
import { FinancialPublication } from './financial-publication';
import { FinancialRating } from './financial-rating';
import { Footer } from './footer';
import { Gouvernance } from './gouvernance';
import { GroupHistory } from './group-history';
import { Header } from './header';
import Home from './home';
import HubActualites from './hub-actus';
import { InnovationByLaPoste } from './innovation-by-la-poste';
import LaPosteEn4 from './la-poste-en-4';
import { MediaPress } from './media-press';
import { Newsroom } from './newsroom';
import { OurBrands } from './our-brands';
import { Postmen } from './postmen';
import { PublicServiceMissions } from './public-service-missions';
import { RewardedInnovation } from './rewarded-innovation';
import { RewardedInnovationPage } from './rewarded-innovation-page';
import { SearchPage } from './search-page';

/**
 * Normalizr schema representing a document
 */
export const Document = new schema.Union(
  {
    [DocumentType.AGENDA]: Agenda,
    [DocumentType.ARTICLE]: Article,
    [DocumentType.BRANCH_ACTIVITIES]: BranchActivities,
    [DocumentType.CONTACT_PAGE]: ContactPage,
    [DocumentType.CONTACT]: Contact,
    [DocumentType.FINANCIAL_DEBT]: FinancialDebt,
    [DocumentType.FINANCIAL_KEY_FIGURES]: FinancialKeyFigures,
    [DocumentType.FINANCIAL_PRESS_RELEASE]: FinancialPressRelease,
    [DocumentType.FINANCIAL_PUBLICATION]: FinancialPublication,
    [DocumentType.FINANCIAL_RATING]: FinancialRating,
    [DocumentType.FOOTER]: Footer,
    [DocumentType.GOUVERNANCE]: Gouvernance,
    [DocumentType.GROUP_HISTORY]: GroupHistory,
    [DocumentType.HEADER]: Header,
    [DocumentType.HOME]: Home,
    [DocumentType.HUB_ACTUS]: HubActualites,
    [DocumentType.INNOVATION_BY_LA_POSTE]: InnovationByLaPoste,
    [DocumentType.LA_POSTE_EN_4]: LaPosteEn4,
    [DocumentType.MEDIA_PRESS]: MediaPress,
    [DocumentType.NEWSROOM]: Newsroom,
    [DocumentType.OUR_BRANDS]: OurBrands,
    [DocumentType.POSTMEN]: Postmen,
    [DocumentType.PUBLIC_SERVICE_MISSIONS]: PublicServiceMissions,
    [DocumentType.REWARDED_INNOVATION_PAGE]: RewardedInnovationPage,
    [DocumentType.REWARDED_INNOVATION]: RewardedInnovation,
    [DocumentType.SEARCH_PAGE]: SearchPage,
  },
  compose(toDocType, prop('type'))
);

/**
 * Normalizr schema representing an array of documents
 */
export const Documents = [Document];
